import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {fetchProducts, setSortBy, selectFilteredProductsCount} from '../store/products';
import {setActiveFilterCategory, setSmallScreen, toggleFilterVisible} from '../store/app';
import Filters from './Filters';
import VisibleProducts from './Products';
import FilterMenuButton from './FilterMenuButton';
import FilterList from './FilterList';
import Select from 'react-select';
import {clearAll} from "../store/filters";

const FilteredPage = props => {
    const dispatch = useDispatch();
    const isFetchingProducts = useSelector(state => state.products.isFetching);
    const activeProductCount = useSelector(selectFilteredProductsCount);

    let smallScreenListener;

    const handleWindowResize = () => {
        dispatch(setSmallScreen(isSmallScreen()));
    }

    const isSmallScreen = () => {
        return window.innerWidth < 767;
    }

    function handleReset(e) {
        e.preventDefault();
        dispatch(setActiveFilterCategory(null));
        dispatch(clearAll());
    }

    React.useEffect(() => {
        // Add default sort
        if(props.defaultSort) {
            dispatch(setSortBy(props.defaultSort));
        }
        // Fetch data
        dispatch(fetchProducts(props.apiUrl));
        // Handle screen size
        dispatch(setSmallScreen(isSmallScreen()));
        smallScreenListener = window.addEventListener("resize", handleWindowResize);
        
        // Inital state of filter is visible, if the screen is a "small screen" set to not visible
        if (isSmallScreen()|| React.Children.count(props.children) == 0) dispatch(toggleFilterVisible());

        // Hook cleanup function
        return () => {
            window.removeEventListener("resize", smallScreenListener);
        }
    },[])

    if (isFetchingProducts) return "loading";

    return (
        <React.Fragment>
            {activeProductCount == 0 && props.localisedStrings.NoProductsAvailable !== undefined &&
                <div className={"noProductsMessage"}>
                    <span>{`${props.localisedStrings.NoProductsAvailable}`}</span>
                    <div><button className={"pill btn"} onClick={handleReset}>Start over</button></div>
                </div>
            }
            
            {React.Children.count(props.children) > 0 && activeProductCount > 0 &&
                <FilterMenu sortList={props.sortList} localisedStrings={props.localisedStrings} />
            }

            {activeProductCount > 0 &&
                <section id={"content"}>
                    {React.Children.count(props.children) > 0 &&
                        <Filters>
                            {props.children}
                        </Filters>
                    }
                    {React.Children.count(props.children) > 0 &&
                        <FilterList />
                    }
                    <VisibleProducts />
                </section>
            }
        </React.Fragment>
    )
}

// FILTER MENU
const FilterMenu = props => {
    const activeProductCount = useSelector(selectFilteredProductsCount);
    const filteredProducts = useSelector(state => state.products.filteredProducts);
    const [sortOptions, setSortOptions] = React.useState([]);
    const dispatch = useDispatch();

    React.useEffect(() => {
        // Set up sort options
        let sO = [];
        let sortNames = Object.getOwnPropertyNames(props.sortList);
        for (let i = 0; i < sortNames.length; i++) {
            sO.push({value: props.sortList[sortNames[i]].value, label: props.sortList[sortNames[i]].label});
        }
        setSortOptions(sO);
    },[])

    return (
        <div id="filterMenu">
                <FilterMenuButton localisedTitle={props.localisedStrings.filter} />
                <div>
                    <span id="productCount">{`${activeProductCount} ${props.localisedStrings.items}`}</span>
                    <Select options={sortOptions} placeholder={props.localisedStrings.sort} className={"sort-select"} classNamePrefix={"sort-select"} isSearchable={false} autoFocus={false}  onChange={(e, a) => {
                        if (a.action === "select-option") {
                            dispatch(setSortBy(props.sortList[e.value]));
                        }
                    }} />
                </div>
            </div>
    )
}

export default FilteredPage;